import * as React from 'react';
import { IPageContent } from '../../types/helper';
import { clickAskProfessional, clickFaq } from '../../utils/events';
import * as style from './InsidePage.css';

export interface IInsidePageContentProps {
  content: IPageContent;
}

export const InsidePageContent = (props: IInsidePageContentProps) => (
  <div className={style['content']}>
    <h1>{props.content.title}</h1>
    <p>{props.content.body}</p>
    <ul className={style['content-list']}>
      {props.content.links.map(({ name, url, label }) => (
        <li key={url}>
          <a onClick={() => clickFaq(label)} href={url}>{name}</a>
        </li>
      ))}
    </ul>
    <p className={style['content-footer']}>
      Не нашли нужной вам информации?{' '}
      <a onClick={clickAskProfessional} href="https://www.cian.ru/add-vopros">Спросите у профессионалов</a>{' '}
      или{' '}
      <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSchgoXzaxnvx5obzuLB9cyucYPhha1KKvGsky-aX-TmZybndQ/viewform">
        оставьте отзыв о Помощнике
      </a>.
    </p>
  </div>
);
